var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 6.5L12.75 21C12.75 21.4142 12.4142 21.75 12 21.75H4.99997C4.58576 21.75 4.24997 21.4142 4.24997 21C4.24997 20.5858 4.58576 20.25 4.99997 20.25H11.25V6.5H12.75Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.81479C11.3096 2.81479 10.75 3.37443 10.75 4.06479C10.75 4.75514 11.3096 5.31479 12 5.31479C12.6903 5.31479 13.25 4.75514 13.25 4.06479C13.25 3.37443 12.6903 2.81479 12 2.81479ZM9.24997 4.06479C9.24997 2.54601 10.4812 1.31479 12 1.31479C13.5188 1.31479 14.75 2.54601 14.75 4.06479C14.75 5.58357 13.5188 6.81479 12 6.81479C10.4812 6.81479 9.24997 5.58357 9.24997 4.06479Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2753 4.05675C13.382 3.65653 13.793 3.4186 14.1932 3.52532L17.9432 4.52532C18.3435 4.63205 18.5814 5.04302 18.4747 5.44324C18.3679 5.84347 17.957 6.0814 17.5567 5.97468L13.8067 4.97468C13.4065 4.86795 13.1686 4.45698 13.2753 4.05675Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7255 3.43994C10.6206 3.84065 10.2107 4.08045 9.81003 3.97555L5.95141 2.96542C5.5507 2.86052 5.3109 2.45064 5.4158 2.04993C5.5207 1.64922 5.93058 1.40942 6.33129 1.51432L10.1899 2.52445C10.5906 2.62935 10.8304 3.03923 10.7255 3.43994Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37883 4.99604C4.9702 3.54151 7.02974 3.54151 7.62111 4.99604L10.0415 10.9492C10.2099 11.3635 10.2323 11.8836 9.96424 12.3463C9.53393 13.0892 8.31525 14.75 5.99997 14.75C3.68469 14.75 2.46601 13.0892 2.0357 12.3463C1.76767 11.8836 1.79005 11.3635 1.95847 10.9492L4.37883 4.99604ZM6.23156 5.56099C6.14708 5.35319 5.85286 5.3532 5.76838 5.56099L3.34801 11.5142C3.3349 11.5464 3.33233 11.5711 3.33274 11.5845C3.33291 11.5904 3.33359 11.5937 3.33399 11.595C3.67819 12.189 4.50424 13.25 5.99997 13.25C7.49614 13.25 8.32223 12.1884 8.66625 11.5945C8.6646 11.5973 8.66685 11.5961 8.6672 11.5845C8.66761 11.5711 8.66503 11.5464 8.65193 11.5142L6.23156 5.56099ZM3.33399 11.595C3.33413 11.5955 3.33397 11.595 3.33399 11.595V11.595Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99997 13.25H2.99997V10.25H8.99997V13.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3788 7.99604C16.9702 6.5415 19.0297 6.54151 19.6211 7.99604L22.0415 13.9492C22.2099 14.3635 22.2323 14.8836 21.9642 15.3463C21.5339 16.0892 20.3153 17.75 18 17.75C15.6847 17.75 14.466 16.0892 14.0357 15.3463C13.7677 14.8836 13.79 14.3635 13.9585 13.9492L16.3788 7.99604ZM18.2316 8.56098C18.1471 8.35319 17.8529 8.35319 17.7684 8.56098L15.348 14.5142C15.3349 14.5464 15.3323 14.5711 15.3327 14.5845C15.3329 14.5904 15.3336 14.5936 15.334 14.595C15.6782 15.189 16.5042 16.25 18 16.25C19.4961 16.25 20.3222 15.1884 20.6663 14.5945C20.6646 14.5973 20.6669 14.5961 20.6672 14.5845C20.6676 14.5711 20.665 14.5464 20.6519 14.5142L18.2316 8.56098ZM15.334 14.595C15.3341 14.5955 15.334 14.595 15.334 14.595V14.595Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 16.5H15V13.5H21V16.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/Scale.08d7aaeff2774b8755341b5ff13524db.svg";
export { ForwardRef as ReactComponent };